import { render } from "./room-header.vue?vue&type=template&id=3416ad7e"
import script from "./room-header.vue?vue&type=script&lang=ts"
export * from "./room-header.vue?vue&type=script&lang=ts"

import "./room-header.vue?vue&type=style&index=0&id=3416ad7e&lang=stylus"
script.render = render

export default script